import { useState } from 'react';
import Button from '../../../components/Button';
import ErrorMessage from '../../../components/ErrorMessage';
import Input from '../../../components/Input';
import Modal from '../../../components/Modal';
import Textarea from '../../../components/Textarea';
import classNames from 'classnames';

const FeedbackModal = ({
  isOpen,
  onCloseModal,
  isLoading,
  formik,
  saveMessage,
}) => {
  const [selectedFeeling, setSelectedFeeling] = useState('like');

  const handleChooseFeeling = (feeling) => {
    setSelectedFeeling(feeling);
    formik.setFieldValue('feeling', feeling);
  };

  const feelingOptions = [
    { name: 'like', icon: '/images/a369/like.svg' },
    { name: 'love', icon: '/images/a369/love.svg' },
    { name: 'wow', icon: '/images/a369/wow.svg' },
    { name: 'sad', icon: '/images/a369/sad.svg' },
    { name: 'angry', icon: '/images/a369/angry.svg' },
  ];

  return (
    <Modal
      isOpen={isOpen}
      onCloseModal={onCloseModal}
      mainContentClassName="max-w-md modal-center"
      title="Góp ý"
      isLoading={isLoading}
    >
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full main-content">
          <div className="w-full my-2">
            <div className="flex items-center w-full">
              <span className="font-semibold text-sm text-gray-700 dark:text-gray-400">
                Vui lòng giúp chúng tôi phục vụ bạn tốt hơn. Xin cảm ơn!
              </span>
            </div>
          </div>
          <div className="flex space-x-3 items-center w-full">
            <span className="font-semibold text-sm text-gray-700 dark:text-gray-400">
              Bước 1:
            </span>
            {feelingOptions.map((option) => (
              <button
                type="button"
                key={option.name}
                className={classNames(
                  'rounded-full pl-2 h-14 w-14 bg-gray-170 dark:bg-gray-150 dark:border-gray-160',
                  selectedFeeling == option.name
                    ? 'border border-primary-main'
                    : ''
                )}
                onClick={() => handleChooseFeeling(option.name)}
              >
                <img className="w-10 h-10" src={option.icon} alt="" />
              </button>
            ))}
          </div>

          <div className="w-full my-2">
            <div className="flex flex-col">
              <span className="font-semibold text-sm text-gray-700 dark:text-gray-400 mb-2">
                Bước 2: Nhập góp ý
              </span>
              <Textarea
                formik={formik}
                name="detail"
                rows="3"
                placeholder="Vui lòng nhập mô tả, mong muốn về các vấn đề góp ý tại đây. Chúng tôi xin lắng nghe và ghi nhận để cải thiện"
              />
            </div>
            <div className="block w-full mt-1">
              <ErrorMessage
                message={
                  formik.touched.detail && formik.errors.detail
                    ? formik.errors.detail
                    : ''
                }
              />
            </div>
          </div>
          <div className="block w-full mt-5">
            <div className="block w-full">
              <Button type="submit" className="w-full">
                Gửi góp ý
              </Button>
              <ErrorMessage message={saveMessage} />
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default FeedbackModal;
